import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "media-bridge-image-preview" */'./MediaBridgeImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('media-bridge-image-preview')),
  LoadingComponent: () => null
});